import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  pageTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: theme.spacing(1.5),
    '&:not(.invoice)': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },
    '&.wrap': {
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap'
      }
    },
    [theme.breakpoints.up('lg')]: {
      '&:not(.invoice)': {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(3)
      }
    }
  },
  pageTitleContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    margin: theme.spacing(2.25, 0),
    '& h1': {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0)
    },
    '& h4': {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0.75),
      color: theme.palette.warning.dark
    },
    columnGap: theme.spacing(1),
    flexWrap: 'wrap'
  },
  backBtn: {
    textTransform: 'none',
    fontSize: theme.typography.pxToRem(16),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    '&:hover, &:focus': {
      color: theme.palette.secondary.main,
      backgroundColor: 'transparent',
      '& svg': {
        left: -10
      }
    },
    '& svg': {
      position: 'relative',
      transition: 'all 0.3s ease-in-out',
      left: 0,
      fontSize: theme.typography.pxToRem(26)
    }

  },
  pageTitle: {
    margin: theme.spacing(2.25, 0),
    '&.single-invoice': {
      fontSize: theme.typography.pxToRem(20),
      '& span': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightSemiBold
      }
    }
  },
  addBtn: {
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightSemiBold,
    fontSize: theme.typography.pxToRem(18)
  },
  pageTitleListCount: {
    marginLeft: theme.spacing(2.5),
    display: 'inline-block',
    background: theme.palette.primary.light,
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: theme.spacing(0.625),
    padding: theme.spacing(0.625, 1.350),
    minWidth: theme.spacing(4.5),
    textAlign: 'center'
  },
  pageActions: {
    '& > button + button,& > button + a,& > a + button,& > a + a': {
      marginLeft: theme.spacing(1.5)
    }
  }
}))
